import { render, staticRenderFns } from "./BtDashboardDesigner.vue?vue&type=template&id=d47a4164&scoped=true&"
import script from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
export * from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardDesigner.vue?vue&type=style&index=0&id=d47a4164&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47a4164",
  null
  
)

export default component.exports